<template>
	<div class="sky-add-input">
		<el-row
			v-for="item in dataList"
			:key="item.id"
			type="flex"
			align="middle"
			justify="space-between"
			class="data-list"
		>
			<p class="value">{{ item.name }}</p>
			<el-button v-if="disabled" type="primary" size="mini" @click="deleteData(item)"
				>删除</el-button
			>
		</el-row>
		<el-row type="flex" align="middle" justify="space-between" class="compnents" v-if="disabled">
			<div class="components-main">
				<sky-select
					v-model="customer"
					:options="options"
					:props="props"
					placeholder="请输入客户名称"
					:remote-method="getOptions"
					filterable
					remote
				>
				</sky-select>
			</div>
			<div class="add-btn" @click="addData">
				<i class="el-icon-circle-plus"></i>
			</div>
		</el-row>
	</div>
</template>

<script>
import dict from '@/backend/services/dictionary/dictionary';
import skySelect from '@/components/iglobalwin/formComponents/sky-select.vue';
export default {
	props: {
		dataList: {
			type: Array,
			default() {
				return [];
			},
		},
		disabled: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			customer: '',
			options: [],
			props: {
				label: 'value',
				value: 'id',
			},
			filterable: true,
			remote: true,
		};
	},
	methods: {
		addData() {
			if (!this.customer) return false;
			this.$emit('add-data', this.customer, () => {
				this.customer = '';
			});
		},
		deleteData(val) {
			this.$emit('delete-data', val);
		},
		getOptions: function (val) {
			dict.getCustomerName({ name: val }).then(val => {
				this.options = val.data;
			});
		},
	},
	components: { skySelect },
};
</script>

<style lang="scss" scoped>
.sky-add-input {
  // border: 1px solid orange;
  .data-list {
    // border: 1px solid red;
    margin: 10px 0;
  }

  .compnents {
    margin-top: 10px;

    .components-main {
      flex: 1;
    }

    .add-btn {
      width: 56px;
      height: 28px;
      margin-left: 10%;
      line-height: 28px;
      text-align: center;
      font-size: 28px;
    }
  }
}
</style>
